import Axios, { AxiosResponse } from "axios";
import { PUSH_NOTIFICATION_PUBLIC_KEY } from "../shared/utilty/constants";
import { KuikaAppManager } from "../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { UserService } from "./user-service";

const backendUrl = KuikaAppManager.GetBackendUrl();

interface ISendPushNotificationToUsernamePayload {
  username: string;
  title: string;
  message: string;
  extraData?: { [key: string | number]: unknown };
}

class NotificationService {
  public static async SendPushNotificationToUsername(
    payload: ISendPushNotificationToUsernamePayload
  ): Promise<AxiosResponse> {
    try {
      return await Axios.post<null, AxiosResponse>(`${backendUrl}/notification/sendtouser`, {
        ...payload,
        extraData: payload.extraData ? JSON.stringify(payload.extraData) : undefined
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}

export async function registerServiceWorker() {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(`${KuikaAppManager.GetFrontEndUrl()}/sw.js`);
      // console.log("Service Worker registered", registration);
      return registration;
    } catch (error) {
      console.error("Service Worker registration failed", error);
    }
  } else {
    console.warn("Service Worker is not supported.");
  }
}

export async function askPermission() {
  if (PUSH_NOTIFICATION_PUBLIC_KEY !== "") {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      throw new Error("Push Notification izni verilmedi");
    }
    return permission;
  }
}

export async function subscribeUser(username: string) {
  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUSH_NOTIFICATION_PUBLIC_KEY)
    });
  }

  const payload = {
    deviceId: subscription.endpoint,
    registrationId: arrayBufferToBase64Url(subscription.getKey("p256dh")),
    appBundleId: arrayBufferToBase64Url(subscription.getKey("auth")),
    userName: username,
    deviceType: 0,
    publicKey: PUSH_NOTIFICATION_PUBLIC_KEY
  };

  UserService.RegisterDevice(payload);
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function arrayBufferToBase64Url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export default NotificationService;
